// TODO: This is a HOC that provides the router v6 props to Class components
// can be extended with other props like history, match, etc.
// Needs to be exctracted to shared-hooks when all apps are migrated to v6

import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";

export interface RouterProps {
  router: {
    location: ReturnType<typeof useLocation>;
    navigate: ReturnType<typeof useNavigate>;
    params: Record<string, string | undefined>;
    searchParams: ReturnType<typeof useSearchParams>;
  };
}

const withRouter = <P extends object>(
  Component: React.ComponentType<P & RouterProps>
) => {
  function ComponentWithRouterProp(props: Readonly<P>) {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();
    const searchParams = useSearchParams();

    return (
      <Component
        {...props}
        router={{ location, navigate, params, searchParams }}
      />
    );
  }

  return ComponentWithRouterProp;
};

export default withRouter;
